import React__default from 'react';
import { dataViewSize } from '@keepeek/commons';
import { LinearProgress, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useRecoilValue } from 'recoil';

var ListDataViewLoading = function (_a) {
    var dataViewKey = _a.dataViewKey;
    var size = useRecoilValue(dataViewSize(dataViewKey));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LinearProgress, { color: "primary" }),
        React__default.createElement(TableContainer, { sx: { width: "100%" } },
            React__default.createElement(Table, { size: "small" },
                React__default.createElement(TableHead, null,
                    React__default.createElement(TableRow, { sx: { backgroundColor: function (theme) { return theme.palette.divider; } } },
                        React__default.createElement(TableCell, { sx: { height: "35px" } }))),
                React__default.createElement(TableBody, null, Array(size)
                    .fill(null)
                    .map(function (_p, i) { return (React__default.createElement(TableRow, { key: i },
                    React__default.createElement(TableCell, { sx: { height: "50px" } }))); }))))));
};

export { ListDataViewLoading };
//# sourceMappingURL=ListDataViewLoading.js.map
